export default __webpack_public_path__ + "static/media/imgNotToken.be6a587d.png";